import Player from './physics/Player';
import CommandInterface from './commands/CommandInterface';
import world from './environment/world';
import THREEParticleEmitter from './particles/THREEParticleEmitter';
import FocusOverlay from './ui/tutorial/FocusOverlay';

export default class common {
	static toggleAudio() {
		common.storage.data.muted = P3.audio.isMute;
		common.storage.save();
	}
}

/**
 * @type {number}
 * @default 1664
*/
common.STAGE_WIDTH = 1664;

/**
 * @type {number}
 * @default 768
*/
common.STAGE_HEIGHT = 768;

/**
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
*/
common.renderer = null;

/**
 * @type {THREE.WebGLRenderer}
*/
common.THREErenderer = null;

/**
 * @type {PIXI.Container}
*/
common.stage = null;

/**
 * @type {THREE.Stage}
*/
common.THREEstage = null;

/**
 * @type {THREE.PerspectiveCamera}
*/
common.camera = null;

/**
 * @type {P3.Ticker}
*/
common.ticker = null;

/**
 * @type {P3.Transitions[]}
*/
common.transitions = null;

/**
 * @type {object}
*/
common.storage = null;

/**
 * @type {CommandInterface}
*/
common.commandInterface = null;

common.config = {};

/**
 * @type {Player};
*/
common.player = null;

/**
 * @type {assets}
*/
common.assets = null;

/**
 * @type {number}
*/
common.currentLevel = 0;

/**
 * @type {object}
*/
common.levelSettings = null;

/**
 * @type {boolean}
*/
common.cheatActive = false;

/**
 * @type {world}
*/
common.world = null;

/**
 * @type {FocusOverlay}
*/
common.focusOverlay = null;

/**
 * @type {number}
 * 0: laboratory
 * 1: temple
 * 2: mine
*/
common.environment = 0;

/**
 * @type {object}
*/
common.competitionData = {};

/**
 * @type {object}
*/
common.entryDetails = {};

/**
 * @type {number}
*/
common.totalScore = 0;

/**
 * @type {THREEParticleEmitter[]}
*/
common.particles3D = [];

common.t = null;

/**
 * @type {object}
 * @param {{points:number, command: number, coin:number}} scoring Score values
*/
common.scoring =
{
	points  : 1000,
	command : 150,
	coin    : 1000
};

/**
 * @type {number}
*/
common.commandScale = 1.34;

/**
 * @type {number}
 * @param {{{width: number, height: number}}}
*/
common.commandDimensions =
{
	width  : Math.floor(162 * common.commandScale),
	height : Math.floor(60 * common.commandScale)
};

/**
 * @type {number}
*/
common.commandSpacing = 4;

/**
 * @type {number}
*/
common.commandTopBottomOffset = 10;

/**
 * @type {number}
*/
common.commandFontSize = ~~(18 * common.commandScale);

/**
 * @type {number}
*/
common.commandFontOffset = 0;	// Why would we need an offset?

/**
 * @type {Object}
 */
common.morphSliderOffsets = {
	'en' : -2,
	'bg' : 18,
	'cz' : 20,
	'nl' : 16,
	'de' : 18,
	'hu' : -2,
	'pl' : 14,
	'ro' : 12,
	'ru' : 14
};

/**
 * @type {number[]}
*/
common.bestScores =
[
	3000,
	3000,
	2000,
	2000,
	2000,
	3150,
	4300,
	7450,
	4450,
	4450,
	6450,
	4150,
	4450,
	5600,
	5300,
	6300,
	6450,
	4600,
	4900,
	3300,
	4000,
	4900,
	5500,
	4750,
	7750,
	3000,
	6450,
	6450,
	6600
];
